import { createApiSlice } from "@common";
import { CRUD_ACTIVITY_NAME, CRUD_ACTIVITY_NAME_BY_ID } from "@routes";

const apiConfig = [
  {
    name: "addActivityName",
    method: "post",
    url: CRUD_ACTIVITY_NAME,
    stateKey: "message",
  },
  {
    name: "getActivityNameById",
    method: "get",
    url: CRUD_ACTIVITY_NAME_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateActivityName",
    method: "put",
    url: CRUD_ACTIVITY_NAME,
    stateKey: "message",
  },
  {
    name: "deleteActivityName",
    method: "delete",
    url: CRUD_ACTIVITY_NAME,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "activityName",
  apiConfig,
  customReducers);
const activityNameSlice = slice;

export default activityNameSlice.reducer;

export const {
  addActivityName,
  getActivityNameById,
  updateActivityName,
  deleteActivityName,
} = thunks;

export const { rowSelect } = actions;
